<template>
    <div ref="searchBox" class="searchGroups">
        <div v-if="status === 'normal'" class="searchGroupDetail">
            <div
                v-for="(item, index) in resultList"
                :key="index"
                class="main-box"
            >
                <label
                    class="member"
                    :for="item.targetId"
                    @change="checkGroups($event, item)"
                >
                    <label
                        class="checkIcon"
                    ><input
                        :id="item.targetId"
                        v-model="selectedGroupIdList"
                        type="checkbox"
                        :value="item.targetId"
                        :half="isHalf(item)"
                    ><i /></label>
                    <GroupAvatar :group="item" class="avatar" />
                    <div class="detail group">
                        <p class="name">
                            <span class="name-flex" v-html="item.htmlName" />
                            <span
                                class="group-count"
                            >({{ item.memberCount }})</span>
                        </p>
                        <div
                            v-if="item.memberList && item.memberList.length > 0"
                            class="position"
                        >
                            包含：
                            <template
                                v-for="(memberItem, index2) in item.memberList"
                            >
                                <span
                                    :key="memberItem.lxAccount"
                                    v-html="
                                        memberItem.name +
                                            (memberItem.nickname
                                                ? '·' + memberItem.nickname
                                                : '') +
                                            '(' +
                                            memberItem.lxAccount +
                                            ')'
                                    "
                                />
                                <template
                                    v-if="index2 !== item.memberList.length - 1"
                                >、</template>
                            </template>
                        </div>
                    </div>
                </label>
            </div>
            <div
                v-if="pageNumber === Math.ceil(total / pageSize)"
                class="noMore"
            >
                没有更多了
            </div>
        </div>
        <div
            v-else-if="status === 'none' && pageNumber === 1"
            class="org-status"
        >
            <img
                src="@/assets/images/contacts/org-window-empty-bg.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                找不到“<span class="no-data">{{ keyword }}</span>”相关的群聊
            </p>
        </div>
        <Loading
            v-else-if="status === 'loading' && pageNumber === 1"
            :search-type="searchType"
        />
        <div v-if="status === 'dataLoadingFailed'" class="org-status">
            <img
                src="@/assets/images/contacts/data_loading_failed.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                数据加载失败，请重试
            </p>
            <!--<div class="status-reload">-->
            <!--    <button type="button" class="reload" @click="reload()">-->
            <!--        重新加载-->
            <!--    </button>-->
            <!--</div>-->
        </div>
        <div v-if="status === 'serviceAbnormal'" class="org-status">
            <img
                src="@/assets/images/contacts/service_abnormal.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                服务异常，请联系IT报事
            </p>
        </div>
        <div v-if="status === 'networkAbnormal'" class="org-status">
            <img
                src="@/assets/images/contacts/network_abnormal.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                当前网络不可用，请检查网络设置
            </p>
        </div>
    </div>
</template>

<script>
import { contactsSearch } from '@/apis/contactsWindow/contactsWindow'
import GroupAvatar from '@/components/GroupAvatar/index'
import Loading from './SkeletonScreen'

export default {
    name: 'SearchGroups',
    components: {
        GroupAvatar,
        Loading
    },
    props: {
        selectedGroups: {
            type: [Array],
            required: false,
            default: () => []
        },
        selectedHalfGroups: {
            type: [Array],
            required: false,
            default: () => []
        },
        keyword: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            status: '',
            resultList: [],
            resultListCache: {},
            resultListPageNumberCache: {},
            total: '', // 搜索群组获取到的总条数
            pageNumber: 1, // 页数
            pageSize: 20, // 每页个数
            searchType: 'group'
        }
    },
    computed: {
        selectedGroupIdList: {
            get() {
                return this.selectedGroups.map(item => item.id)
            },
            set() {}
        }
    },
    watch: {
        keyword(val) {
            if (val && val.length > 0) {
                this.initData()
            }
        }
    },
    mounted() {
        this.$refs.searchBox.addEventListener('scroll', this.loadMore)
    },
    methods: {
        initData() {
            this.status = 'loading'
            this.pageNumber = 1
            this.resultList = []
        },
        // 搜索群组
        getData(value, isChangeTab) {
            const context = this
            // 切换tab如果有缓存那么就不发请求
            if (isChangeTab && context.resultListCache[context.keyword]) {
                context.resultList = context.resultListCache[context.keyword]
                context.pageNumber =
                    context.resultListPageNumberCache[context.keyword]
                context.status = 'normal'
                return
            }
            context.status = 'loading'
            context.pageNumber = 1
            const params = {
                keyword: value,
                channel: 'web',
                searchType: context.searchType,
                pageNumber: context.pageNumber,
                pageSize: context.pageSize
            }
            contactsSearch(params)
                .then(res => {
                    if (res.code === '0' && res.data !== null) {
                        if (context.keyword !== res.data.keyword) {
                            return
                        }
                        const resultList = res.data.groupList || []
                        if (resultList.length === 0) {
                            context.status = 'none'
                            return
                        }
                        context.resultList = context.formatGroupData(resultList)
                        context.resultListCache[context.keyword] =
                            context.resultList // 缓存搜索到的列表
                        context.resultListPageNumberCache[context.keyword] =
                            context.pageNumber // 缓存当前搜索页数
                        context.total = res.data.totalElements
                        context.status = 'normal'
                    } else {
                        context.status = 'dataLoadingFailed'
                    }
                })
                .catch(err => {
                    console.warn(err)
                    if (err.message === 'Network Error') {
                        this.status = 'networkAbnormal' // 当前网络不可用，请检查网络设置
                    } else {
                        this.status = 'serviceAbnormal' // 服务异常，请联系IT报事
                    }
                })
        },
        loadMore() {
            const context = this
            const pagesNum = Math.ceil(context.total / context.pageSize)
            if (context.pageNumber >= pagesNum) {
                return
            }
            const el = context.$refs.searchBox
            let locked = true // 防止重复调用
            const fill = 1
            const bottom =
                el.scrollTop + el.clientHeight + fill > el.scrollHeight
            if (bottom && locked) {
                locked = false
                context.pageNumber += 1
                const params = {
                    keyword: context.keyword,
                    channel: 'web',
                    searchType: context.searchType,
                    pageNumber: context.pageNumber,
                    pageSize: context.pageSize
                }
                contactsSearch(params).then(res => {
                    if (res.code === '0') {
                        const resultList = res.data.groupList || []
                        context.resultList = context.resultList.concat(
                            context.formatGroupData(resultList)
                        )
                        context.resultListCache[context.keyword] =
                            context.resultList
                        context.resultListPageNumberCache[context.keyword] =
                            context.pageNumber
                        locked = true
                    }
                })
            }
        },
        // 格式化从后端获取的数据
        formatGroupData(list) {
            const tempList = []
            const reg = /<\/?.+?>/g
            for (let i = 0; i < list.length; i++) {
                let obj = {}
                if (list[i].targetId) {
                    obj = {
                        targetId: list[i].targetId || '', // 群组头像用
                        id: list[i].targetId || '', // 给群组一个id,addedGroup、removedGroup需要id
                        name: list[i].targetName
                            ? list[i].targetName.replace(reg, '')
                            : '',
                        htmlName: list[i].targetName || '',
                        portraitUrl: list[i].icon || '',
                        memberCount: list[i].targetNum || '',
                        memberList: list[i].memberList || []
                    }
                    tempList.push(obj)
                }
            }
            return tempList
        },
        isHalf(item) {
            const idList = this.selectedHalfGroups.map(item => item.id)
            return idList.indexOf(item.targetId) > -1
        },
        // 选择群组
        checkGroups(event, groupItem) {
            this.$emit('checkGroups', event, groupItem)
        }
    }
}
</script>

<style lang="scss" scoped>
.searchGroups {
    height: 100%;
    overflow-y: auto;
    .searchGroupDetail {
        .member {
            display: flex;
            align-items: center;
            height: 54px;
            cursor: pointer;
            border-radius: 4px;
            margin: 0 6px;
            padding: 0 6px;
            &:hover {
                background: #f5f5f5;
            }
            .avatar {
                width: 36px;
                height: 36px;
                margin: 0 12px;
            }
            .detail.group {
                flex: 1;
                overflow: hidden;
                .name {
                    font-size: 14px;
                    line-height: 22px;
                    color: #323232;
                    overflow: hidden;
                    display: flex;
                    .name-flex {
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        max-width: 170px;
                        padding-right: 6px;
                        ::v-deep .search_high_light {
                            color: #007af5;
                        }
                    }
                    .group-count {
                        flex: 1;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }
                .position {
                    width: 100%;
                    font-size: 12px;
                    line-height: 18px;
                    color: #999999;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    ::v-deep .search_high_light {
                        color: #007af5;
                    }
                }
            }
            .expandIcon {
                font-size: 18px;
                color: #c1c1c1;
            }
        }
        .noMore {
            width: 100%;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #999;
            font-size: 12px;
            border-top: 1px solid #f5f5f5;
        }
    }
    .checkIcon {
        cursor: pointer;
        display: flex;
        align-items: center;
        input {
            display: none;
            & + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-default.png');
                background-size: 100% 100%;
            }
            &:checked + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-ok.png');
                background-size: 100% 100%;
            }
            &:checked[disabled] + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-no.png');
                background-size: 100% 100%;
            }
            &[disabled] + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-disableno.png');
                background-size: 100% 100%;
            }
            &[half] + i {
                width: 24px;
                height: 24px;
                display: block;
                background: url('../../../assets/images/contacts/org-window-choose-half.png');
                background-size: 100% 100%;
            }
        }
    }
    .org-status {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        //padding-bottom: 94px;
        //box-sizing: border-box;
        .status-img {
            width: 90px;
            height: 90px;
        }
        .status-text {
            font-size: 14px;
            line-height: 22px;
            color: #464646;
            text-align: center;
            padding: 12px;
            box-sizing: border-box;
            .no-data {
                color: #007af5;
            }
        }
        .status-reload {
            width: 180px;
            height: 36px;
            margin-top: 18px;
            .reload {
                width: 100%;
                height: 36px;
                font-size: 14px;
                color: #fff;
                text-align: center;
                line-height: 36px;
                border: 0;
                background: #007af5;
                border-radius: 2px;
                cursor: pointer;
                &:hover {
                    background-color: #006edd;
                }
            }
        }
    }
}
</style>
